/**
 * Minimal jQuery.cookie polyfill for legacy Halo theme scripts (theme.js,
 * product.js, multi-level-category, etc.) when the plugin was not loaded yet.
 */
(function () {
  'use strict';

  var jq = window.jQuery || window.$;
  if (!jq || typeof jq.cookie === 'function') return;

  jq.cookie = function (name, value, options) {
    if (typeof value !== 'undefined') {
      options = options || {};
      if (value === null) {
        value = '';
        options.expires = -1;
      }
      var expires = '';
      if (
        options.expires &&
        (typeof options.expires === 'number' || options.expires.toUTCString)
      ) {
        var date;
        if (typeof options.expires === 'number') {
          date = new Date();
          date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
        } else {
          date = options.expires;
        }
        expires = '; expires=' + date.toUTCString();
      }
      var path = options.path ? '; path=' + options.path : '';
      var domain = options.domain ? '; domain=' + options.domain : '';
      var secure = options.secure ? '; secure' : '';
      document.cookie = [
        name,
        '=',
        encodeURIComponent(String(value)),
        expires,
        path,
        domain,
        secure
      ].join('');
      return undefined;
    }

    var result = null;
    if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i += 1) {
        var cookie = jq.trim(cookies[i]);
        if (cookie.substring(0, name.length + 1) === name + '=') {
          result = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return result;
  };

  if (window.jQuery && !window.jQuery.cookie) {
    window.jQuery.cookie = jq.cookie;
  }
  if (window.$ && !window.$.cookie) {
    window.$.cookie = jq.cookie;
  }
})();
